module.exports = __webpack_public_path__ + "static/media/azentio.d4090850.jpg";